import React, { useState } from "react";
import "./Pages.css";

const Survey: React.FC = () => {
  const [feedback, setFeedback] = useState({ name: "", email: "", message: "" });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFeedback({ ...feedback, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`Thank you ${feedback.name}, your feedback has been submitted!`);
    setFeedback({ name: "", email: "", message: "" });
  };

  return (
    <div className="page-container">
      <h1>Customer Survey</h1>
      <p>We value your feedback! Please fill out the survey to help us improve our services.</p>
      <form onSubmit={handleSubmit} className="contact-form">
        <input type="text" name="name" placeholder="Name" value={feedback.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" value={feedback.email} onChange={handleChange} required />
        <textarea name="message" placeholder="Your Feedback" value={feedback.message} onChange={handleChange} rows={5} required />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Survey;
